import { IFormSubmitRequest, IGetFormsRequest } from '../../interfaces/form.interface'
import { IInspectionWindowsRequest } from '../../interfaces/inspection-compliance.interface'

export class GetOneOfficialForm {
  static readonly type = '[form] Get One Official Form'
  constructor(
    public payload: string,
    public isHistory = false,
    public isWeeklyTireReport = false
  ) {}
}

export class GetOfficialForms {
  static readonly type = '[form] Get Official Forms'
  constructor(
    public payload: IGetFormsRequest,
    public isWeeklyTireReport = false
  ) {}
}

export class SubmitOfficialForm {
  static readonly type = '[form] Submit Official Form'
  constructor(
    public payload: IFormSubmitRequest,
    public isWeeklyTireReport = false
  ) {}
}

export class ResetFormHistoryItem {
  static readonly type = '[form] Reset Form History Item'
}

export class GetInspectionCompliance {
  static readonly type = '[form] Get Inspection Compliance'
}

export class AdminGetInspectionWindows {
  static readonly type = '[form] Admin Get Inspection Windows'
}

export class AdminUpdateInspectionWindows {
  static readonly type = '[form] Admin Update Inspection Windows'
  constructor(public payload: IInspectionWindowsRequest) {}
}
